export const routes = [
  {
    path: "/sala-principal/:id/sala-tempo",
    component: () => import(/* webpackChunkName: "ur" */ "./components/List"),
    name: "sala.indicadores.municipio.sala-tempo",
  },
];
